// extracted by mini-css-extract-plugin
export default {"data":"memberships_data__tz4A5","dataLabel":"memberships_dataLabel__kuE06","dataItem":"memberships_dataItem__rdOSE"};